<div class="wrap-layout">
    <router-outlet />
</div>
<app-menu></app-menu>